module.exports = __webpack_public_path__ + "static/img06-7580f3b388687c38536c26f49bd9a46b.jpg";